export default function isMobile() {
  return window.matchMedia('(max-width: 1200px)').matches;
}
